<template>
  <div
    class="border border-blue-3 rounded-2xl overflow-hidden grid"
    :style="'grid-template-columns: repeat(' + numberOfColumns + ', minmax(0, 1fr));'">
    <!-- Grid template columns style used as tailwind didn't want to generate   -->
    <div
      v-for="(tableContent, index) in tableData"
      :key="index"
      class="flex justify-between items-center p-1 md:p-[20px] border-r border-blue-5 h-mobileNavBarHeight border-t overflow-hidden"
      :class="{
        'bg-blue-5 border-x-blue-3': tableContent.fieldType === 'heading',
        'border-r-0': index % numberOfColumns === numberOfColumns - 1,
      }">
      <p
        v-if="tableContent.fieldType === 'heading'"
        class="button-2 md:text-button1 text-blue-1 md:border-blue-3 flex items-center">
        {{ tableContent.component }}
      </p>
      <div
        v-else-if="tableContent.fieldType === 'html'"
        class="button-2 text-grey-1"
        v-html="tableContent.component" />
      <component
        v-else-if="tableContent"
        :is="tableContent.component"
        :value="tableContent.value"
        :name="tableContent.name"
        :type="tableContent.fieldType"
        :class="tableContent.class"
        :disabled="tableContent.disabled"
        @input="$emit('input', $event.target.value, tableContent.name)" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { TableDataType } from '@/types/CallcentrePortalTypes.ts'

defineEmits(['input'])
defineProps<{
  tableData: Array<TableDataType>
  numberOfColumns: number
}>()
</script>

<style scoped></style>
